import { Calendar } from 'lucide-react';
import Section from './Section.jsx';
import { timeRangesToWords } from '../lib/format.js';

// Accented card, not the pink one. charlestonpink is the site's ALERT color (the
// stale-brief banner, the rain flag), and using it here meant the same pink said
// "warning" and "there's a ballgame tonight" on one page. This now uses the
// shared accented-card treatment: cream tint with a gold left rule, the same
// shape the guide callouts use.
export default function TonightInTown({ tonight }) {
  if (!tonight) return null;
  // A vetted venue once carried a trailing space and the headline rendered
  // "Credit One Stadium , 7 PM". The worker trims its inputs now; this keeps
  // the seam clean at render either way.
  // The dash pass is the same render-time guard the week list got: 21 of the
  // 117 archived briefs carry "8 AM–2 PM" here and none of them regenerate.
  // It fires only between two clock readings, because this field is prose and
  // a dash elsewhere in it would belong to an event's own name.
  const headline = timeRangesToWords(tonight.headline).replace(/\s+,/g, ',');
  // "In town today", not "Tonight in town": the pick is often a daytime event.
  // On 2026-09-26 it was the farmers market at Marion Square, 8 AM to 2 PM,
  // under a heading that promised the evening. The new title still fits a
  // concert or a ballgame.
  return (
    <Section title="In town today" eyebrow="Worth knowing">
      <div className="rounded-xl border border-navy-100 border-l-2 border-l-cream-500 bg-cream-100/60 px-5 py-4">
        <div className="mb-1 flex items-center gap-2">
          <Calendar className="h-4 w-4 shrink-0 text-cream-600" aria-hidden="true" />
          <h3 className="font-display text-lg font-semibold text-navy-900">{headline}</h3>
        </div>
        <p className="text-sm leading-relaxed text-navy-800">{tonight.details}</p>
        {tonight.url && (
          <a
            href={tonight.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-block text-xs font-medium uppercase tracking-[0.14em] text-navy-800 underline-offset-2 hover:text-navy-900"
          >
            Tickets <span aria-hidden="true">›</span>
          </a>
        )}
      </div>
    </Section>
  );
}
